import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.BLOQUEIO.BLOQUEAR.RESET_BLOQUEAR](state) {
		state.ids = []
		state.idItemAta = null
		state.justificativa = null
		state.isBloquear = null
	},
}
